module.exports = __webpack_public_path__ + "static/Tradeweb-164f01784b94acb90c2c3a91e83c1b58.png";